import React, {Component} from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter, Label, Row, Col, InputGroup, Input, Container} from 'reactstrap';
import {AvForm, AvGroup, AvInput, AvField} from 'availity-reactstrap-validation';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../../i18next';

import {convertStringToBoolean, convertStringToNumber} from '../../../../utils/CommonUtils';

const POSSIBLE_PREPARATION_TIME_PEAK_DAYS = {
    validOnMonday: 'Mon',
    validOnTuesday: 'Tue',
    validOnWednesday: 'Wed',
    validOnThursday: 'Thu',
    validOnFriday: 'Fri',
    validOnSaturday: 'Sat',
    validOnSunday: 'Sun'
}

const INITIAL_STATE = {
    preparationTime: {
        id: null,
        fromHour: null,
        fromMinute: null,
        toHour: null,
        toMinute: null,
        duration: null,
        validOnMonday: false,
        validOnTuesday: false,
        validOnWednesday: false,
        validOnThursday: false,
        validOnFriday: false,
        validOnSaturday: false,
        validOnSunday: false
    },
    stateAlreadyCopiedFromProps: false
};

class PreparationTimeScreen extends Component {
    constructor(props) {
        super(props);

        this.state = INITIAL_STATE;

        this.changeNumberAttributeState = this.changeNumberAttributeState.bind(this);
        this.changeBooleanAttributeState = this.changeBooleanAttributeState.bind(this);
        this.closeScreen = this.closeScreen.bind(this);
        this.saveChanges = this.saveChanges.bind(this);
    }

    copyStateFromProps() {
        const {preparationTime} = this.props;
        
        if (preparationTime !== undefined && preparationTime !== null &&
            (preparationTime.id === null || preparationTime.id !== this.state.preparationTime.id) &&
            !this.state.stateAlreadyCopiedFromProps) {

            const preparationTimeCopyFromProps = {
                id: preparationTime.id,
                fromHour: preparationTime.fromHour,
                fromMinute: preparationTime.fromMinute,
                toHour: preparationTime.toHour,
                toMinute: preparationTime.toMinute,
                duration: preparationTime.duration,
                validOnMonday: preparationTime.validOnMonday,
                validOnTuesday: preparationTime.validOnTuesday,
                validOnWednesday: preparationTime.validOnWednesday,
                validOnThursday: preparationTime.validOnThursday,
                validOnFriday: preparationTime.validOnFriday,
                validOnSaturday: preparationTime.validOnSaturday,
                validOnSunday: preparationTime.validOnSunday
            }

            this.setState({
                preparationTime: preparationTimeCopyFromProps,
                stateAlreadyCopiedFromProps: true
            });
        }

        POSSIBLE_PREPARATION_TIME_PEAK_DAYS.validOnMonday = i18n.t('screens:preparationTimes.mon')
        POSSIBLE_PREPARATION_TIME_PEAK_DAYS.validOnTuesday = i18n.t('screens:preparationTimes.tue')
        POSSIBLE_PREPARATION_TIME_PEAK_DAYS.validOnWednesday = i18n.t('screens:preparationTimes.wed')
        POSSIBLE_PREPARATION_TIME_PEAK_DAYS.validOnThursday = i18n.t('screens:preparationTimes.thu')
        POSSIBLE_PREPARATION_TIME_PEAK_DAYS.validOnFriday = i18n.t('screens:preparationTimes.fri')
        POSSIBLE_PREPARATION_TIME_PEAK_DAYS.validOnSaturday = i18n.t('screens:preparationTimes.sat')
        POSSIBLE_PREPARATION_TIME_PEAK_DAYS.validOnSunday = i18n.t('screens:preparationTimes.sun')
    }

    resetState() {
        this.setState(INITIAL_STATE);
    }

    changeNumberAttributeState({target}) {
        const value = convertStringToNumber(target.value);

        this.setState({
            preparationTime: {
                ...this.state.preparationTime,
                [target.name]: value
            }
        });
    }

    changeBooleanAttributeState({target}) {
        const checked = convertStringToBoolean(target.checked);

        this.setState({
            preparationTime: {
                ...this.state.preparationTime,
                [target.name]: checked
            }
        });
    }

    getValue(value) {
        if (value === 0) {
            return '00';
        }

        return value || '';
    }

    saveChanges() {
        if (this.state.preparationTime.duration == null
            || this.state.preparationTime.fromHour == null
            || this.state.preparationTime.toHour == null || this.state.preparationTime.fromMinute == null
            || this.state.preparationTime.toMinute == null) {
            return;
        }

        if(this.props.onSave(this.state.preparationTime)) {
            // Let the parent screen close this one if there are no errors
            // since the validation for overlapping preparation times is made there.
            // this.props.onToggle();
            this.resetState();
        }
    }

    closeScreen() {
        this.props.onToggle();
        this.resetState();
    }


    renderFromTo() {

        const {explanationStyle, columnsDelimiterStyle, numberInputColumnStyle} = styles;

        return (
            <Row>
                <Col xs={6}>
                    <Label>{i18n.t('screens:preparationTimes.from')}
                        <small style={explanationStyle}>{i18n.t('screens:preparationTimes.timeFormat')}</small>
                    </Label>
                </Col>
                <Col xs={6}>
                    <Label>{i18n.t('screens:preparationTimes.to')}
                        <small style={explanationStyle}>{i18n.t('screens:preparationTimes.timeFormat')}</small>
                    </Label>
                </Col>
                <Col style={numberInputColumnStyle}>
                    <AvField type="number" id="fromHour" name="fromHour" placeholder={i18n.t('screens:preparationTimes.hoursAbbreviation')}
                             value={this.getValue(this.state.preparationTime.fromHour)}
                             min={0} max={23} onKeyPress={(e) => this.validateHoursValues(e)}
                             onChange={this.changeNumberAttributeState}
                             errorMessage={i18n.t('common:validations.invalid')}
                             required={true}/>
                </Col>
                <div style={columnsDelimiterStyle}>:</div>
                <Col style={numberInputColumnStyle}>
                    <AvField type="number" id="fromMinute" name="fromMinute" placeholder={i18n.t('screens:preparationTimes.minutesAbbreviation')}
                             value={this.getValue(this.state.preparationTime.fromMinute)}
                             min={0} max={59} onKeyPress={(e) => this.validateMinutesValues(e)}
                             onChange={this.changeNumberAttributeState}
                             errorMessage={i18n.t('common:validations.invalid')}
                             required={true}/>
                </Col>
                <Col style={numberInputColumnStyle}>
                    <AvField type="number" id="toHour" name="toHour" placeholder={i18n.t('screens:preparationTimes.hoursAbbreviation')}
                             value={this.getValue(this.state.preparationTime.toHour)}
                             min={0} max={23} onKeyPress={(e) => this.validateHoursValues(e)}
                             onChange={this.changeNumberAttributeState}
                             errorMessage={i18n.t('common:validations.invalid')}
                             required={true}/>
                </Col>
                <div style={columnsDelimiterStyle}>:</div>
                <Col style={numberInputColumnStyle}>
                    <AvField type="number" id="toMinute" name="toMinute" placeholder={i18n.t('screens:preparationTimes.minutesAbbreviation')}
                             value={this.getValue(this.state.preparationTime.toMinute)}
                             min={0} max={59} onKeyPress={(e) => this.validateMinutesValues(e)}
                             onChange={this.changeNumberAttributeState}
                             errorMessage={i18n.t('common:validations.invalid')}
                             required={true}/>
                </Col>
            </Row>
        );
    }

    validateHoursValues(e) {

        var inputKeyCode = e.keyCode ? e.keyCode : e.which;

        if (inputKeyCode != null) {
            if (inputKeyCode == 45 || inputKeyCode == 46 || inputKeyCode == 43
                || inputKeyCode == 69 || inputKeyCode == 101 ) {
                e.preventDefault();
            }

            if((e.target.name == 'fromHour' || e.target.name == 'toHour')  && inputKeyCode > 51 && inputKeyCode < 48 ){
                e.preventDefault();
            }
        }
    }

    validateMinutesValues(e) {

        var inputKeyCode = e.keyCode ? e.keyCode : e.which;

        if (inputKeyCode != null) {
            if (inputKeyCode == 45 || inputKeyCode == 46 || inputKeyCode == 43
                || inputKeyCode == 69 || inputKeyCode == 101 ) {
                e.preventDefault();
            }
        }
    }

    renderDuration() {

        const {explanationStyle, numberInputColumnStyle} = styles;

        return (
            <Row>
                <Col xs={12}>
                    <Label>{i18n.t('screens:jobsHistoryScreen.duration')}
                        <small style={explanationStyle}>({i18n.t('screens:preparationTimes.minutes')})</small>
                    </Label>
                </Col>
                <Col style={numberInputColumnStyle}>
                    <AvField type="number" id="duration" name="duration" placeholder={i18n.t('screens:preparationTimes.minutesAbbreviation')}
                             value={this.getValue(this.state.preparationTime.duration)}
                             onChange={this.changeNumberAttributeState}
                             errorMessage={i18n.t('common:validations.errorMsg')}
                             required={true}
                             onKeyPress={(e) => this.validateMinutesValues(e)}
                             min={0}
                             />
                </Col>
            </Row>
        );
    }

    renderDaysHeader() {
        const {headerStyle} = styles;

        return (
            <Row>
                <div style={headerStyle}>
                    <Label>{i18n.t('screens:preparationTimes.validOnDays')}</Label>
                </div>
            </Row>
        );
    }

    renderDaysSeparator() {
        const {headerStyle} = styles;

        return (
            <Row>
                <div style={headerStyle}>
                </div>
            </Row>
        );
    }

    renderDays() {
        const {checkboxInputStyle} = styles;

        return Object.keys(POSSIBLE_PREPARATION_TIME_PEAK_DAYS).map((property, index) => {
            const label = POSSIBLE_PREPARATION_TIME_PEAK_DAYS[property];
            return (
                <Col key={index} xs={3}>
                    <InputGroup>
                        <Label for={property}>{label}</Label>
                        <Input type="checkbox" id={property} name={property} style={checkboxInputStyle}
                               checked={this.state.preparationTime[property]}
                               onChange={this.changeBooleanAttributeState}/>
                    </InputGroup>
                </Col>
            );
        });
    }

    renderDay(property, label) {
        const {checkboxInputStyle} = styles;

        return (
            <Col xs={3}>
                <AvGroup>
                    <Label for={property}>{label}</Label>
                    <AvInput type="checkbox" id={property} name={property} style={checkboxInputStyle}/>
                </AvGroup>
            </Col>
        );
    }

    render() {
        const {modalBodyStyle, preparationTimeModalContainer} = styles;

        this.copyStateFromProps();

        return (
            <div>
                <Modal isOpen={this.props.isOpen} toggle={this.closeScreen}>
                    <AvForm className="modalForm" onValidSubmit={this.saveChanges}>
                        <ModalHeader className="modalHeader"
                                     toggle={this.closeScreen}>{i18n.t('screens:preparationTimes.peakPrepTime')}</ModalHeader>
                        <ModalBody style={modalBodyStyle}>
                            <Container style={preparationTimeModalContainer}>
                                {this.renderDaysHeader()}
                                <Row>
                                    {this.renderDays()}
                                </Row>
                                {this.renderDaysSeparator()}
                                {this.renderFromTo()}
                                {this.renderDuration()}
                            </Container>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="primary">
                                <MaterialIcon icon="check" color="#fff" size={20}/>&nbsp;{i18n.t('common:buttons.apply')}
                            </Button>
                        </ModalFooter>
                    </AvForm>
                </Modal>
            </div>
        );
    }
}

export default PreparationTimeScreen;

const styles = {
    modalBodyStyle: {
        paddingBottom: 0
    },
    headerStyle: {
        width: '100%',
        marginLeft: 15,
        marginRight: 15,
        marginBottom: 15,
        borderBottom: "1px solid rgb(222, 226, 230)"
    },
    columnsDelimiterStyle: {
        paddingTop: 10,
        color: 'rgb(169, 169, 169)'
    },
    numberInputColumnStyle: {
        flex: '0 0 24.5%',
        maxWidth: '24.5%'
    },
    checkboxInputStyle: {
        position: "relative",
        marginLeft: 10
    },
    explanationStyle: {
        color: 'rgb(169, 169, 169)'
    },
    preparationTimeModalContainer: {
        backgroundColor: '#f8f8f8',
        paddingTop: 10,
        paddingBottom: 10,
        border: '1px solid #E9ECEF',
        marginBottom: 16
    }
};


// WEBPACK FOOTER //
// ./src/components/restaurants/settings/service/PreparationTimeScreen.js